import gql from 'graphql-tag';

export const NAME =
  'compositions_CaseActivityPanel_CallHistory_caseCallHistory';

export default gql`
  query ${NAME} (
    $caseNumber: String!
  ) {
    case (
      caseNumber: $caseNumber
    ) {
      id
      callHistory {
        edges {
          node {
            amazonConnectContactId
            destinationName
            destinationNumber
            destinationOrganization
            direction
            sourceName
            sourceNumber
            sourceOrganization
            startTime
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseActivityPanel/CallHistory/withCallHistory/caseCallHistoryQuery.js